<template>
  <div class="iso-card iso-depth-side isometric-card" @click="goDetail">
    <div class="card-cover">
      <img
        v-if="coverImage"
        :src="coverImage"
        :alt="title"
        loading="lazy"
        class="card-cover-img"
      />
      <div v-else class="card-cover-placeholder">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <span v-if="category" class="card-category iso-tag">{{ category }}</span>
    </div>
    <div class="card-body">
      <h3 class="card-title">{{ title }}</h3>
      <p v-if="summary" class="card-summary">{{ summary }}</p>
      <div class="card-meta">
        <span v-if="date" class="card-date">{{ date }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const props = defineProps<{
  title: string
  summary?: string
  coverImage?: string
  date?: string
  category?: string
  slug?: string
  id?: number | string
}>()

const router = useRouter()

function goDetail() {
  if (props.id) {
    router.push(`/article/${props.id}`)
  } else if (props.slug) {
    router.push(`/article/${props.slug}`)
  }
}
</script>

<style scoped>
.isometric-card {
  cursor: pointer;
  overflow: hidden;
}

.card-cover {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
}

.card-cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.isometric-card:hover .card-cover-img {
  transform: scale(1.06);
}

.card-cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.06) 0%, rgba(0, 212, 255, 0.02) 100%);
  color: var(--iso-cyan-dim);
}

.card-category {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
}

.card-body {
  padding: 16px 20px 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  line-height: 1.5;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s;
}

.isometric-card:hover .card-title {
  color: var(--iso-cyan);
}

.card-summary {
  font-size: 13px;
  color: var(--iso-text-dim);
  line-height: 1.6;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-date {
  font-size: 12px;
  color: var(--iso-text-dim);
}
</style>
